import { Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const ProvincePerformanceRanking = ({ loading, error, data, onRetry }) => {
  const rows = data?.provinceRanking || data?.ProvinceRanking || [];

  return (
    <ManagementWidgetShell
      title="رتبه‌بندی استان‌ها"
      subheader="عملکرد و تأخیر به تفکیک استان"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {!rows.length && !loading && !error ? (
        <Typography color="text.secondary">داده استانی یافت نشد.</Typography>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>استان</TableCell>
                <TableCell align="right">درخواست</TableCell>
                <TableCell align="right">ظرفیت (kW)</TableCell>
                <TableCell align="right">قرارداد</TableCell>
                <TableCell align="right">بهره‌برداری</TableCell>
                <TableCell align="right">تبدیل</TableCell>
                <TableCell align="right">تأخیر میانگین</TableCell>
                <TableCell align="right">SLA نقض</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => {
                const id = pick(row, "provinceId", "ProvinceId");
                const href = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));
                return (
                  <TableRow key={id} hover>
                    <TableCell>
                      {href ? (
                        <Link component={RouterLink} to={href} underline="hover">
                          {pick(row, "provinceTitle", "ProvinceTitle")}
                        </Link>
                      ) : (
                        pick(row, "provinceTitle", "ProvinceTitle")
                      )}
                    </TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "requestCount", "RequestCount"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "totalCapacityKw", "TotalCapacityKw"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "contractCount", "ContractCount"))}</TableCell>
                    <TableCell align="right">{formatNumber(pick(row, "commissionedCount", "CommissionedCount"))}</TableCell>
                    <TableCell align="right">
                      {pick(row, "conversionRate", "ConversionRate") != null
                        ? `${formatNumber(pick(row, "conversionRate", "ConversionRate"), 1)}٪`
                        : "—"}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "averageDelayDays", "AverageDelayDays") != null
                        ? formatNumber(pick(row, "averageDelayDays", "AverageDelayDays"), 1)
                        : "—"}
                    </TableCell>
                    <TableCell align="right">
                      {pick(row, "overduePercent", "OverduePercent") != null
                        ? `${formatNumber(pick(row, "overduePercent", "OverduePercent"), 1)}٪`
                        : "—"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </ManagementWidgetShell>
  );
};

export default ProvincePerformanceRanking;
